var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _g2, _path20, _path21, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagForEcuador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 32H2c0 5.5 1.5 10.6 4 15h52c2.5-4.4 4-9.5 4-15",
    fill: "#2a5f9e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 2C15.4 2 2 15.4 2 32h60C62 15.4 48.6 2 32 2z",
    fill: "#ffe62e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62c11.1 0 20.8-6 26-15H6c5.2 9 14.9 15 26 15",
    fill: "#ed4c5c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.383 29.553l.802.82l.344-.937l.115-.586c-.115-1.64 0-3.28 0-3.28l.23.235l-.918-.937l-.573-.585v5.27",
    fill: "#034ea2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.644 28.85l.802-2.46l-.802-.82v3.28",
    fill: "#ed1c24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.383 24.283l.573.585l-2.751-2.81c-.115-.118-.115 2.459-.115 5.27l2.293 2.342v-5.387",
    fill: "#fd0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.185 39.508c-1.948-1.171-2.178-4.802-2.178-5.388v-6.324l.574.586l-2.752-2.811c-.229-.234 0 7.612 0 11.009c0 1.64 1.032 7.378 6.764 4.45c0 0 2.866-1.054 3.783-2.342h-.573c-.115.117-.23.117-.344.117c-3.325 2.342-5.274.703-5.274.703",
    fill: "#fd0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.007 34.12c0 .469.23 4.1 2.064 5.27c0 0 1.949 1.64 5.388-.585c-1.032.469-1.834.469-2.408.351c-1.605-.468-3.324-2.342-3.553-4.333c-.23-1.99-.23-5.739-.23-5.739l.23.235l-.917-.937l-.574-.469v6.207",
    fill: "#034ea2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.415 31.661v-1.523c-.344-.35.114.118-.803-.82l-.229-.234v.118c0 .468 0 3.864.23 5.621c.229 1.991 1.948 3.865 3.553 4.333c.573.118 1.376.118 2.407-.35c.115 0 .115-.118.23-.118c-3.096-.351-5.044-3.162-5.388-7.027",
    fill: "#ed1c24"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.878 39.625c1.835-1.171 2.179-4.802 2.064-5.27V28.03l-.573.586l2.751-2.81c.23-.235 0 7.612 0 11.008c0 1.64-1.032 7.378-6.764 4.45c0 0-2.866-1.053-3.783-2.342h.574c.114 0 .229.117.229.117c3.554 2.226 5.502.586 5.502.586",
    fill: "#fd0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.942 34.238c0 .468-.23 4.099-2.064 5.27c0 0-1.948 1.64-5.388-.586c1.032.469 1.835.469 2.408.352c1.605-.469 3.324-2.343 3.554-4.334c.229-1.99.229-5.738.229-5.738l-.23.234l.918-.937l.573-.586v6.325",
    fill: "#034ea2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.65 31.778v-1.522l.802-.82l.229-.234v.117c0 .468 0 3.864-.23 5.621c-.229 1.991-1.834 3.865-3.553 4.45c-.573.118-1.376.118-2.408-.35c-.114 0-.114-.118-.229-.118c2.98-.468 5.044-3.279 5.388-7.144",
    fill: "#ed1c24"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3 31c0 4.1 2.6 7.4 5.7 7.4s5.7-3.3 5.7-7.4s-2.6-7.4-5.7-7.4s-5.7 3.4-5.7 7.4",
    fill: "#8cddea"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3 31.3c0 4.1 2.6 7.4 5.7 7.4c3.2 0 5.7-3.3 5.7-7.4H26.3",
    fill: "#6dd337"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 31.5l10.8.2l.1-.8c0-.1.2-.2-.1-.2c-1.2-.1-.7-.2-1.4-.2c-.2 0-4.8-1.1-5.2-1.1c-.4-.1-4 .5-4 .5l-.2 1.6",
    fill: "#557176"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 29.6l1.7.7s2.2-.4 2.4-.3c.2.1 2.1.4 2.2.4h2.9h-.1c-.2-.1-2.4-.7-2.6-.8c-.1-.1-1.8-.7-1.9-.9c-.2-.2-1.4-.9-1.6-.9c-.2-.1-3 1.8-3 1.8",
    fill: "#ffffff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 23.8s-1.1-.7-2.5-.7c-1.1 0-2.2.6-2.2.6c-1.2.7-2.2 2-2.8 3.6c-.4 1.1-.7 2.4-.7 3.7c0 3.9 2.1 6.9 4.8 7.7c0 0 .4.2.9.2s1-.1 1-.1c2.7-.7 4.9-3.8 4.9-7.7c0-5.1-3.9-7.7-3.4-7.3M33 38.3s-.5.1-1 .1s-1-.1-1-.1c-2.4-.7-4.3-3.6-4.3-7.1c0-1.2.3-2.5.7-3.5c.6-1.4 1.5-2.6 2.6-3.2c0 0 1.1-.7 2-.7c1.3 0 2.3.7 2.3.7c1.8 1.1 3.1 3.7 3.1 6.6c-.1 3.6-2 6.6-4.4 7.2",
    fill: "#b1babf"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 31.2l1.7 2.3l-2.6 1.5s.2.6.7 1.3c.5.6 1.7 1.9 2.8 2c1.2.1 2 .1 2.7-.3c.6-.4 1.5-.9 2.1-1.9c.6-.9.6-1.1.6-1.1s-3.8-.8-3.9-.8c-.1-.1-3.7-2.9-3.8-3c-.1-.1.8-1.2.8-1.2l-1.1 1.2z",
    fill: "#034ea2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1c24",
    d: "M31.1 39.8H33v4.9h-1.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#034ea2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6 40.2h1.9v4.9h-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 40.2h1.9v4.9h-1.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fd0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2 40.2h1.2v6.2h-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 40.2h1.2v6.2h-1.2z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M27.5 38.1h9v2.4h-9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6 18.5c-1.8 0-3.7 2-5.6 2s-3.8-2-5.6-2c-1.7 0-8.4 2-8.4 2c9.3 0 14 5 14 5s4.7-5 14-5c0 0-6.7-2-8.4-2",
    fill: "#594640"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 19.7,
    r: 1.2,
    fill: "#f9f9f9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForEcuador);
export default __webpack_public_path__ + "static/media/flag-for-ecuador.8d0105609775edf6f64dc9a1617e47d4.svg";
export { ForwardRef as ReactComponent };